import { useMemo } from "react";

interface Props {
  type: "organization" | "product" | "breadcrumb";
  data?: Record<string, any>;
}

const JsonLdSchema = ({ type, data }: Props) => {
  const schema = useMemo(() => {
    if (type === "organization") {
      return {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Noor E Borka",
        url: "https://kenani-borka-bazar.lovable.app",
        logo: "https://kenani-borka-bazar.lovable.app/logo.png",
        description: "Premium women's fashion ecommerce — luxury clothing, elegant designs, and curated collections.",
        sameAs: [],
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer service",
          availableLanguage: ["Bengali", "English"],
        },
      };
    }
    if (type === "product" && data) {
      return {
        "@context": "https://schema.org",
        "@type": "Product",
        name: data.name,
        image: data.image,
        description: data.description || data.name,
        sku: data.sku || data.id,
        brand: { "@type": "Brand", name: "Noor E Borka" },
        offers: {
          "@type": "Offer",
          url: data.url,
          priceCurrency: "BDT",
          price: data.offer_price || data.price,
          availability: (data.stock ?? 1) > 0
            ? "https://schema.org/InStock"
            : "https://schema.org/OutOfStock",
          seller: { "@type": "Organization", name: "Noor E Borka" },
        },
        ...(data.rating && {
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: data.rating,
            bestRating: 5,
            ratingCount: data.ratingCount || 1,
          },
        }),
      };
    }
    if (type === "breadcrumb" && data?.items) {
      return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: data.items.map((item: any, i: number) => ({
          "@type": "ListItem",
          position: i + 1,
          name: item.name,
          item: item.url,
        })),
      };
    }
    return null;
  }, [type, data]);

  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default JsonLdSchema;
